import { useEffect, useState } from "react";

function DownloadNotice() {
  const [visible, setVisible] = useState(false);
  const [appLogo, setAppLogo] = useState("");
  const [selectedBrand, setSelectedBrand] = useState('localhost');

  // Initialize visibility and reset hide flag on hard reload
  useEffect(() => {
    const navEntries = performance.getEntriesByType("navigation");
    const navType = navEntries.length > 0 ? navEntries[0].type : "navigate";
    if (navType === "reload") {
      sessionStorage.removeItem("barHidden");
    }
    const hidden = sessionStorage.getItem("barHidden") === "true";
    setVisible(!hidden);
  }, []);

  // Fetch app logo from API (prefer mobile_logo -> logo -> loader_logo)
  useEffect(() => {
    let cancelled = false;
    const fetchLogo = async () => {
      try {
        if (!process.env.REACT_APP_API_URL) return;
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!res.ok) return;
        const json = await res.json();
        const item = Array.isArray(json) ? json[0] : json;
        const picked = item?.mobile_logo || item?.logo || item?.loader_logo || "";
        if (!cancelled) setAppLogo(picked || "");
      } catch (err) {
        // silent fallback
        console.debug("downloadNotice: using fallback logo");
      }
    };
    fetchLogo();
    return () => {
      cancelled = true;
    };
  }, []);

  // Hide bar handler
  const handleClose = (e) => {
    e.stopPropagation();
    sessionStorage.setItem("barHidden", "true");
    setVisible(false);
  };
 useEffect(() => {
    const hostname = (window.location.hostname || '').toLowerCase();
    const origin = (window.location.origin || '').toLowerCase();
    const search = (window.location.search || '').toLowerCase();
    const params = new URLSearchParams(window.location.search);
    const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

    const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
    const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
    const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
    const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');

    const selectedBrand = isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : (isBk8bd || isCb444) ? 'bk8bd' : 'default';

    localStorage.setItem('brand', selectedBrand);
    setSelectedBrand(selectedBrand);
  
    
  
  
   
  }, []);
  if (!visible) return null;

  const origin = window.location.origin
    .replace(/^https?:\/\/(www\.)?/, "")
    .replace(/(\.com|\.live|\.net|\.world)$/i, "");

  const logoSrc = appLogo && process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/storage/${appLogo.replace(/^\/?storage\//i, "")}`
    : "/logo.png";

  return (
    <div className={`download-bar show-bar`}>
      <div className="download-bar-icon">
        <img src={logoSrc} alt="app-icon" />
      </div>

      <a href={`./app/${origin}.apk`} className="download-bar-center">
        <div className="shell-download-btn">Download</div>
      </a>

      <a href={`./app/${origin}.apk`} className="download-bar-btn">Download</a>
      <div className="download-bar-close" onClick={handleClose} />

      <div className="app-full-name-wrap">
        <span className="app-full-name">অ্যাপডাউনলোড</span>
      </div>

      <div className="app-star-grade">
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="grade-text">5.0</span>
      </div>
    </div>
  );
}

export default DownloadNotice;
